import { FollowUpsBucketPage } from '../../components/common/LeadFollowUpViews';

export default function EmployeeFollowUps() {
  return <FollowUpsBucketPage roleBasePath="/employee" />;
}
